
















































































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { BootInventory } from './BootInventory';
import { BootStatus } from './Enums';
import { BootType } from './BootType';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';

const bootManagementAdmin = Vue.extend({
    props: ['location'],
    data() {
        return {
            editBoot: { isAddBoot: false } as any as BootInventory,
            addBoot: { isAddBoot: true } as any as BootInventory,
            bootInventorys: [] as BootInventory[],
            BootStatus,
            bootType: [] as BootType[],
            selectedBoot: null,
            loadingBoots: {} as { [inventoryID: string]: boolean },
            validationErrors: {} as { [key: string]: string[] },
        };
    },
    computed: {
        bootStatusNames(): string[] {
            return Object.keys(this.BootStatus).filter(keyVal => isNaN(keyVal as any));
        },
        currentType(): (bootTypeId: number) => string {
            return (bootTypeId: number) => {
                const bType = this.bootType.find(i => i.recID === bootTypeId);
                if (bType) {
                    return bType.bootTypeDescription!;
                }
                return bootTypeId.toString();
            };
        }
    },
    methods: {
        editing(boot: BootInventory) {
            if ((boot as any).isAddBoot) {
                return true;
            }
            else if (this.editBoot && this.editBoot.inventoryID && !(this.editBoot as any).isAddBoot) {
                return this.editBoot.inventoryID === boot.inventoryID;
            }
            else {
                return false;
            }
        },
        edit(boot: BootInventory) {
            this.editBoot = { ...boot };
        },
        add() {
            this.editBoot = { ...this.addBoot };
        },
        async save(boot: BootInventory) {
            Vue.set(this.loadingBoots, boot.inventoryID, true);
            try {
                if ((boot as any).isAddBoot) {
                    await VatsAPI.post(`/${this.location}/BootManagementAdmin/AddBootInventory`, boot);
                }
                else {
                    await VatsAPI.post(`/${this.location}/BootManagementAdmin/UpdateBootInventory`, boot);
                }

                await this.refreshBoots();
            }
            catch (e) {
                this.validationErrors = getValidationErrors(e.response);
                throw e;
            }
            finally {
                Vue.set(this.loadingBoots, boot.inventoryID, false);
            }

            this.cancelEdit();
        },
        async deleteboot(boot: BootInventory) {
            const deleteConfirmMessage = this.$i18n.t('admin.bootManagement.deleteConfirmMessage').toString() + `, ${boot.inventoryID}?`;
            const deleteConfirmTitle = this.$i18n.t('admin.bootManagement.deleteConfirmTitle').toString();
            const deleteButton = this.$i18n.t('common.delete').toString();
            const cancelButton = this.$i18n.t('common.cancel').toString();

            const confirmDelete = await this.$bvModal.msgBoxConfirm(
                deleteConfirmMessage,
                {
                    title: deleteConfirmTitle,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'info',
                    okTitle: deleteButton,
                    cancelTitle: cancelButton,
                    centered: true
                }
            );

            if (confirmDelete) {
                try {
                    Vue.set(this.loadingBoots, boot.inventoryID, true);
                    await VatsAPI.post(`/${this.location}/BootManagementAdmin/DeleteBootInventory`, boot);
                    await this.refreshBoots();
                    Vue.set(this.loadingBoots, boot.inventoryID, false);
                }
                catch (e) {
                    this.$bvToast.toast(this.$i18n.t('admin.bootManagement.deletebootError').toString(), {
                        title: this.$i18n.t('common.error').toString(),
                        autoHideDelay: 5000
                    });
                    throw e;
                }
            }
        },
        cancelEdit() {
            this.editBoot = { isAddBoot: false } as any as BootInventory;
            this.addBoot = { isAddBoot: true } as any as BootInventory;
        },
        async refreshBoots() {
            try {
                this.bootInventorys = (await VatsAPI.get<BootInventory[]>(`/${this.location}/BootManagementAdmin/GetBootInventory`)).data;
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.bootManagement.refreshbootError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        },
        async getMeOnly() {
            try {
                this.refreshBoots();
            }
            catch (e) {
                this.$bvToast.toast(this.$i18n.t('admin.bootManagement.refreshBootError').toString(), {
                    title: this.$i18n.t('common.error').toString(),
                    autoHideDelay: 5000
                });
                throw e;
            }
        }
    },
    async mounted() {
        this.bootType = (await VatsAPI.get<BootType[]>(`${this.location}/BootManagementAdmin/bootType`)).data;
        this.refreshBoots();
    }
});

export default bootManagementAdmin;
